import * as constants from "./revisionConstants";

export const fetchRevisionStatuses = (data) => {
  return {
    type: constants.FETCH_REVISION_STATUSES,
    data,
  };
};

export const fetchRevisionStatusesSuccess = (data) => {
  return {
    type: constants.FETCH_REVISION_STATUSES_SUCCESS,
    data: data,
  };
};

export const fetchRevisionStatusesError = (data) => {
  return {
    type: constants.FETCH_REVISION_STATUSES_ERROR,
    data: data,
  };
};

export const updateRevisionStatuses = (data) => {
  return {
    type: constants.UPDATE_REVISION_STATUSES,
    data: data,
  };
};

export const updateRevisionStatusesSuccess = (data) => {
  return {
    type: constants.UPDATE_REVISION_STATUSES_SUCCESS,
    data: data,
  };
};

export const updateRevisionStatusesError = () => {
  return {
    type: constants.UPDATE_REVISION_STATUSES_ERROR,
  };
};

export const updateRevisionsOrder = (data) => {
  return {
    type: constants.UPDATE_ORDER_REVISION_STATUS,
    data: data,
  };
};

export const updateRevisionsOrderSuccess = (data) => {
  return {
    type: constants.UPDATE_ORDER_REVISION_STATUS_SUCCESS,
    data: data,
  };
};

export const updateRevisionsOrderError = () => {
  return {
    type: constants.UPDATE_ORDER_REVISION_STATUS_ERROR,
  };
};

export const deleteRevisionStatuses= (data) => {
  return {
    type: constants.DELETE_REVISION_STATUSES,
    data: data,
  };
};

export const deleteRevisionStatusesSuccess = (data) => {
  return {
    type: constants.DELETE_REVISION_STATUSES_SUCCESS,
    data: data,
  };
};

export const deleteRevisionStatusesError = () => {
  return {
    type: constants.DELETE_REVISION_STATUSES_ERROR,
  };
};

export const createRevisionStatuses = (data, id) => {
  return {
    type: constants.CREATE_REVISION_STATUSES,
    data: data,
  };
};

export const createRevisionStatusesSuccess = (data) => {
  return {
    type: constants.CREATE_REVISION_STATUSES_SUCCESS,
    data: data,
  };
};

export const createRevisionStatusesError = (id) => {
  return {
    type: constants.CREATE_REVISION_STATUSES_ERROR,
    id,
  };
};

export const isAddingAction = (data) => {
  return {
    type: constants.IS_ADDING_UPDATE,
    data,
  };
};
